import { render, staticRenderFns } from "./EditNewRate.vue?vue&type=template&id=36937cf7&"
import script from "./EditNewRate.vue?vue&type=script&lang=js&"
export * from "./EditNewRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports